import React from 'react';
import Link from '@v2/shared/components/Link';
import { cn } from '@v2/shared/lib/utils';
import { Category } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

type Props = {
  categories?: Category[];
};

/**
 * The same category list, in the panel the hamburger opens.
 *
 * headless: apps/topmags/layouts/MainLayout/Navigation/MobileCategories. All three legacy
 * headers move the one `<nav>` between the header and a drawer with a jQuery plugin
 * (`js-module="responsive:move"`, `snapper:toggle`) that the V2 tree has no counterpart
 * for, so the phone gets its own list instead — which is what headless did too.
 *
 * A list of links written as a list: headless drew a `<div>` per category and left React
 * warning about the missing key, and both are fixed here.
 */
export default function MobileCategories({ categories }: Props) {
  const { buildUrl } = useUrlGenerator();

  if (!categories) {
    return <div />;
  }

  return (
    <ul className="m-0 w-full list-none p-0">
      {categories.map((category, index) => (
        <li
          key={category.id ?? index}
          className={cn(
            'py-2 text-center',
            index === categories.length - 1 ? '' : 'border-0 border-b border-solid border-slate-100'
          )}
        >
          <Link href={buildUrl(category.href)} className="text-sm text-slate-700 no-underline">
            {category.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
